// src/context/AyuntamientoContext.jsx
import React, { createContext, useContext, useState, useEffect } from 'react';
import axios from 'axios';


const AyuntamientoContext = createContext();

export const AyuntamientoProvider = ({ children }) => {

    const [configAyto, setConfigAyto] = useState(null);      // 🏛 IDENTIDAD
    const [globalConfig, setGlobalConfig] = useState(null);  // 🎨 ESTÉTICA
    const [loadingAyto, setLoadingAyto] = useState(false);

    // src/context/AyuntamientoContext.jsx

const cargarAyuntamiento = async (slug) => {
    if (!slug || configAyto?.url_slug === slug) return;

    try {
        setLoadingAyto(true);

        // ✅ AHORA BUSCA EN TU CARPETA PUBLIC/BUILD DIRECTAMENTE
        const res = await axios.get(`/api/public/config/${slug}/index.json`);
        const data = res.data;

        setConfigAyto(data);
        setGlobalConfig(data);

        console.log("🏛️ Contexto cargado desde local:", data.nombre);

    } catch (error) {
        console.error("❌ Error cargando configuración local:", error.message);
    } finally {
        setLoadingAyto(false);
    }
};

    // 🚀 AUTOLOAD GLOBAL (V5): Al refrescar (F5), el contexto recupera el pueblo solo
    useEffect(() => {
        const pathSegments = window.location.pathname.split('/');
        const slug = pathSegments[1];

        // Reservamos palabras que no son slugs de pueblos
        const reservadas = ['admin', 'login', 'superadmin', 'search'];

        if (slug && !reservadas.includes(slug)) {
            cargarAyuntamiento(slug);
        }
    }, []);

    return (
        <AyuntamientoContext.Provider 
            value={{ 
                configAyto,
                globalConfig,
                setConfigAyto,
                setGlobalConfig,
                cargarAyuntamiento,
                loadingAyto
            }}
        >
            {children}
        </AyuntamientoContext.Provider>
    );
};

export const useAyuntamiento = () => useContext(AyuntamientoContext);